import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { path } from 'ramda'
import React from 'react'

import { placesClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Places($search: String, $filter: PlaceFilter) {
    places(limit: 900000, search: $search, filter: $filter) {
      id
      type
    }
  }
`

export const useGetAllPlaces = type => {
  const filter = useCleanFilterForRequest()
  const call = usePromiseQuery(QUERY, {
    variables: { filter: { ...filter, types: type } },
    client: placesClient
  })
  return () => call().then(path(['data', 'places']))
}

//TODO: Use useGetAllPlaces func
const SelectAllPlacesLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={placesClient}
      {...props}
    />
  )
}

export default SelectAllPlacesLink
